import { TaskPriority, TaskStatus } from "@common/types/task";
import type { TaskBulkUpdateAction } from "@common/schemas/task.schema";
import type { InjectedCommandOption } from "@components/commands/lib";

const STATUS_OPTIONS_CONFIG: Array<{
    status: TaskStatus;
    label: string;
    keywords: string[];
}> = [
    { status: TaskStatus.TODO, label: "Todo", keywords: ["todo", "to do"] },
    {
        status: TaskStatus.IN_PROGRESS,
        label: "In progress",
        keywords: ["in progress", "progress"],
    },
    {
        status: TaskStatus.DONE,
        label: "Done",
        keywords: ["done", "complete", "completed"],
    },
    {
        status: TaskStatus.CANCELLED,
        label: "Canceled",
        keywords: ["cancelled", "canceled"],
    },
];

interface BuildTaskBulkOptionsParams {
    isPending: boolean;
    applyAction: (action: TaskBulkUpdateAction) => void;
}

export const buildTaskBulkStatusOptions = ({
    isPending,
    applyAction,
}: BuildTaskBulkOptionsParams): InjectedCommandOption[] =>
    STATUS_OPTIONS_CONFIG.map(({ status, label, keywords }) => ({
        id: `set-status-${status}`,
        label,
        keywords,
        disabled: isPending,
        onSelect: () => applyAction({ type: "status", status }),
    }));

export const buildTaskBulkPriorityOptions = ({
    isPending,
    applyAction,
}: BuildTaskBulkOptionsParams): InjectedCommandOption[] => [
    {
        id: "priority-none",
        label: "No priority",
        keywords: ["none", "clear", "remove priority"],
        disabled: isPending,
        onSelect: () => applyAction({ type: "priority", priority: null }),
    },
    ...Object.values(TaskPriority).map((priority): InjectedCommandOption => ({
        id: `priority-${priority}`,
        label: priority.charAt(0).toUpperCase() + priority.slice(1),
        keywords: [priority],
        disabled: isPending,
        onSelect: () => applyAction({ type: "priority", priority }),
    })),
];
